import classes from './MainTitle.module.css';
import { useTranslation } from 'react-i18next';
import TitleLine from '../../Assets/TitleLine/TitleLine';
import TitleHeader from '../../Assets/TitleHeader/TitleHeader';
import Select from 'react-select';
import { useEffect, useState } from 'react';
import { Employee } from '../../../contexts/interfaces';
import { convertDate } from '../../../utils/convertDate';

interface SearchLabel {
    value: number,
    label: string
};

interface Props {
    setSearchEmployeeId: (val: number | undefined) => void
    employeesInUnit: Employee[]
};

const MainTitle = ({ setSearchEmployeeId, employeesInUnit }: Props) => {
    // Set translation
    const { t } = useTranslation();

    const [searchOptions, setSearchOptions] = useState<SearchLabel[]>([]);

    useEffect(() => {
        let modifiedArray: SearchLabel[] = [];

        employeesInUnit.forEach(emp => {
            modifiedArray.push({
                label: `${emp.firstName} ${emp.lastName} (${convertDate(emp.dateOfBirth)})`,
                value: emp.employeeId
            })
        });

        employeesInUnit && modifiedArray && setSearchOptions([...modifiedArray]);
    }, [employeesInUnit])

    return (
        <>
            <div className={classes.mainTitleContainer}>
                <TitleHeader
                    headerText={t('mainTitle.title')}
                />
                <Select
                    className={classes.search}
                    isSearchable={true}
                    options={searchOptions}
                    placeholder={t('search.placeholder')}
                    onChange={(e) => e ? setSearchEmployeeId(e.value) : setSearchEmployeeId(undefined)}
                    noOptionsMessage={({ inputValue }) => inputValue ? t("search.noOptions") : null}
                    isClearable={true}
                />
            </div>
            <TitleLine />
        </>
    )
};

export default MainTitle;